import { AbstractController } from './abstract-controller.js';
export class EventsController extends AbstractController {
    constructor(host, component, events) {
        super(host, component);
        events.forEach(({ name }) => {
            component.addEventListener(name, ((evt) => {
                const s = '-changed';
                if (name.endsWith(s)) {
                    const { knob } = host.getKnob(name.replace(s, ''));
                    host.syncKnob(component, knob);
                }
                this.data = [...this.data, evt];
            }));
        });
    }
}
//# sourceMappingURL=events-controller.js.map